import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  
  connect() {
    // Close dropdown when clicking outside
    this.clickOutsideHandler = this.clickOutside.bind(this);
    document.addEventListener("click", this.clickOutsideHandler);
    
    // Ensure the menu has high z-index
    if (this.hasMenuTarget) {
      this.menuTarget.style.zIndex = "500";
      this.menuTarget.style.position = "absolute";
    }
  }
  
  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler);
  }
  
  clickOutside(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains('hidden')) {
      this.close();
    }
  }
  
  toggle(event) {
    // Prevent the click from propagating and triggering form submission
    event.preventDefault();
    event.stopPropagation();
    
    // Force menu to have high z-index when opening
    this.menuTarget.style.zIndex = "500";
    
    // Check if dropdown is visible
    const isVisible = !this.menuTarget.classList.contains('hidden');
    
    // Close all dropdowns first
    document.querySelectorAll('[data-controller="dropdown"] [data-dropdown-target="menu"]').forEach(menu => {
      if (!menu.classList.contains('hidden')) {
        menu.classList.add('hidden');
      }
    });
    
    // Toggle the current dropdown (open if it was closed)
    if (isVisible) {
      this.menuTarget.classList.add('hidden');
    } else {
      this.menuTarget.classList.remove('hidden');
    }
  }
  
  close(event) {
    // If called from an event, don't interfere with other click handlers
    if (event) {
      event.stopPropagation()
    }
    this.menuTarget.classList.add('hidden');
  }
}
